export default "__VITE_ASSET__f4e999f5__"